<template>
  <FormOverlay>
    <div class="h-full flex flex-col">
      <div class="mx-2 lg:mx-8 mt-2 lg:mt-8 mb-2 lg:mb-4">
        <div class="flex justify-between items-center">
          <button class="btn btn-ghost btn-square text-accent" :class="tab === 'comments' ? '' : 'btn-disabled'"
            @click="tab = 'overview'">
            <ChevronLeftIcon v-if="tab === 'comments'" class="w-6 h-6" />
          </button>
          <h1 class="text-accent text-lg lg:text-xl mb-1 px-0 lg:px-4 text-center">
            {{ selectedPin?.title }}
          </h1>
          <button class="btn btn-ghost btn-square text-accent" @click="$emit('close')">
            <XMarkIcon class="w-6 h-6" />
          </button>
        </div>
      </div>

      <div class="overflow-y-auto" :class="tab === 'comments' ? 'max-h-64' : 'grow'">
        <p class="mx-8 p-1 border-accent rounded break-words border">
          <span className="text-accent font-semibold">{{ $t('locationLabel') }}:</span>&nbsp;{{
            selectedPin?.location
          }}
        </p>
        <p class="mx-8 mt-2 break-words whitespace-pre-wrap" v-html="linkifiedText" />
      </div>

      <div v-if="!selectedPin?._id.startsWith('organization')" class="overflow-y-auto" :class="tab === 'comments' ? 'grow' : 'shrink-0'">
        <PinModalOverviewTab v-if="tab === 'overview'" @show-comments="tab = 'comments'" />
        <PinModalCommentsTab v-else-if="tab === 'comments'" @show-overview="tab = 'overview'" />
      </div>
    </div>
  </FormOverlay>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { usePinsStore } from '@/stores/pins'
import { ChevronLeftIcon, XMarkIcon } from '@heroicons/vue/24/outline'
import { storeToRefs } from 'pinia'

import FormOverlay from '@/components/FormOverlay.vue'
import PinModalCommentsTab from '@/components/PinModalCommentsTab.vue'
import PinModalOverviewTab from '@/components/PinModalOverviewTab.vue'

const pinsStore = usePinsStore()
const { selectedPin } = storeToRefs(pinsStore)

const tab = ref<'overview' | 'comments'>('overview')

defineEmits<{
  (e: 'close'): void
}>()

const linkifiedText = computed(() => {
      const urlPattern = /(\b(https?):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
      return selectedPin.value ? selectedPin.value.description.replace(urlPattern, '<a href="$1" target="_blank" class="underline">$1</a>') : '';
    });
</script>
